__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/a6a3703/_next/";